import { Component, Input, type OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Store } from '@ngrx/store'
import {
  ChannelRentalAVGRatingItem,
  ChannelReviewItem,
  getChannelMaxRating,
  ReviewService,
  ReviewsInsights,
  ReviewsInsightsGuestSentiment,
} from '@tokeet-frontend/reviews'
import { ActionFailed, isSomething, Toaster } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'
import { of, throwError } from 'rxjs'
import { catchError, filter, startWith, switchMap, tap } from 'rxjs/operators'
import { ReviewInsightsGuestSentimentsDialogService } from '../review-insights-guest-sentiments-dialog/review-insights-guest-sentiments-dialog.dialog.service'

@Component({
  selector: 'app-rental-review-insights',
  templateUrl: './rental-review-insights.component.html',
  styleUrls: ['./rental-review-insights.component.scss'],
})
export class RentalReviewInsightsComponent implements OnInit {
  isExternalRental = false
  @Input() set rentalId(rentalId: string) {
    this.isExternalRental = !!rentalId
    this.rentalIdCtrl.setValue(rentalId)
  }

  ratingByRentalId: Record<string, ChannelRentalAVGRatingItem> = {}
  @Input() set data(data: ChannelRentalAVGRatingItem[]) {
    this.ratingByRentalId = lodash.keyBy(data, (t) => t.rentalId)
    if (!this.rentalIdCtrl.value) {
      this.rentalIdCtrl.setValue(data?.[0]?.rentalId)
    }
  }

  rentalIdCtrl = new FormControl('')

  insights: ReviewsInsights
  isLoading = false

  reviewsByIds: Record<string, ChannelReviewItem> = {}

  constructor(
    private store: Store<any>,
    private reviewService: ReviewService,
    private toastr: Toaster,
    private reviewInsightsGuestSentimentsDialog: ReviewInsightsGuestSentimentsDialogService
  ) {}

  ngOnInit(): void {
    this.rentalIdCtrl.valueChanges
      .pipe(
        startWith(this.rentalIdCtrl.value),
        filter((rentalId) => !!rentalId),
        tap(() => {
          this.isLoading = true
          this.insights = null
        }),
        switchMap((rentalId) =>
          this.reviewService.getRentalReviewInsights(rentalId).pipe(
            catchError((error) => {
              if (error?.status === 412) {
                this.toastr.warning($localize`No reviews found for this rental`)
                return of(null)
              } else {
                return throwError(error)
              }
            })
          )
        ),
        tap(() => (this.isLoading = false))
      )
      .subscribe(
        (res) => {
          this.insights = res
        },
        (error) => {
          this.isLoading = false
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  getMaxRating = (item: ChannelReviewItem) => getChannelMaxRating(item.source)

  getReviews(ids: string[]) {
    if (!isSomething(ids)) return
    this.reviewService.searchReviews({ ids, includeStats: false }).subscribe(
      (data) => {
        this.reviewsByIds = lodash.keyBy(data.reviews, (t) => t._id)
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  onGuestSentiments(items: ReviewsInsightsGuestSentiment[]) {
    this.reviewInsightsGuestSentimentsDialog.open(items)
  }
}
